// @ts-nocheck
import React from 'react';
import { Dialog, DialogSuspense } from '@/components';
import withDialogRedux from '@/components/DialogReduxConnect';
import { compose } from '@/utils';

const SalesOrderMailDialogBody = React.lazy(
  () => import('./SalesOrderMailDialogBody'),
);

/**
 * Sales order mail dialog.
 */
function SalesOrderMailDialog({
  dialogName,
  payload: { salesOrderId = null },
  isOpen,
}) {
  return (
    <Dialog
      name={dialogName}
      title={'Sales Order Mail'}
      isOpen={isOpen}
      canEscapeJeyClose={false}
      isCloseButtonShown={false}
      autoFocus={true}
    >
      <DialogSuspense>
        <SalesOrderMailDialogBody salesOrderId={salesOrderId} />
      </DialogSuspense>
    </Dialog>
  );
}
export default compose(withDialogRedux())(SalesOrderMailDialog);